/** Invite sharing: the WhatsApp deep link and the short message that carries an invite URL. */
type InvitePurpose = 'onboard' | 'reregister' | 'admin_enroll';

/** wa.me wants the number without '+' or spaces; Indian numbers are stored as +91XXXXXXXXXX. */
export function whatsappNumber(phone: string | null | undefined): string | null {
  if (!phone) return null;
  const digits = phone.replace(/\D/g, '');
  return /^91\d{10}$/.test(digits) ? digits : digits.length >= 10 ? digits : null;
}

export function inviteShareMessage(
  firstName: string | null | undefined,
  url: string,
  purpose: InvitePurpose | string,
): string {
  const hi = firstName?.trim() ? `Hi ${firstName.trim()},` : 'Hi,';
  const validity = 'The link works once and expires in 72 hours.';
  if (purpose === 'reregister') {
    return `${hi} here is your new SIVA Attendance link for your new phone. Open it on that phone and follow the fingerprint / Face ID step. ${validity}\n${url}`;
  }
  if (purpose === 'admin_enroll') {
    return `${hi} here is your SIVA Attendance admin enrolment link. Open it on the device that will hold your passkey. ${validity}\n${url}`;
  }
  return `${hi} welcome to SIVA Logistics. Open this link on your own phone to set up attendance with your fingerprint / Face ID. ${validity}\n${url}`;
}

/**
 * https://wa.me/<number>?text=<message>: opens WhatsApp on a phone and WhatsApp Web on a desktop.
 * Null when there is no usable number (admins enrol by email).
 */
export function whatsappShareUrl(phone: string | null | undefined, text: string): string | null {
  const number = whatsappNumber(phone);
  if (!number) return null;
  return `https://wa.me/${number}?text=${encodeURIComponent(text)}`;
}
